import React from 'react';
import { Icon } from '@chakra-ui/react';

interface LogoInterface{
  color: string,
  boxSize: string,
}

export const Logo = (props:LogoInterface) => {
  return (
    <Icon viewBox="0 0 241.15 241.15" {...props}>
<g>
	<g>
		<path fill="#EB6C31" d="M162.069,111.146l-41.641-3.895l-41.64,3.895c0,0-23.052,6.816-22.308,39.439l9.666-5.843
			c0,0-7.435,13.146,0,33.11l8.923-5.843c0,0,7.436,31.65,28.257,54.047l2.974-5.843c0,0,3.718,11.199,14.128,20.937
			c10.41-9.738,14.128-20.937,14.128-20.937l2.975,5.843c20.82-22.397,28.256-54.047,28.256-54.047l8.923,5.843
			c7.436-19.963,0-33.11,0-33.11l9.666,5.843C185.12,117.962,162.069,111.146,162.069,111.146z"/>
		<path fill="#FCE6D4"d="M148.859,133.762l-28.431-2.66l-28.43,2.66c0,0-15.738,4.654-15.23,26.928l6.6-3.989
			c0,0-5.077,8.976,0,22.605l6.093-3.989c0,0,5.076,21.608,19.291,36.901l2.031-3.989c0,0,2.538,7.646,9.645,14.295
			c7.107-6.649,9.647-14.295,9.647-14.295l2.03,3.989c14.215-15.292,19.292-36.901,19.292-36.901l6.092,3.989
			c5.077-13.63,0-22.605,0-22.605l6.6,3.989C164.596,138.417,148.859,133.762,148.859,133.762z"/>
		<path fill="#EB6C31" d="M178.191,65.084c0,0,13.975-27.968-22.359-61.245c0,0,2.329,6.744,0,12.971
			c0,0,1.863-7.852-6.521-16.81c0,0,8.385,17.011-3.262,32.823c-11.646,15.812-25.154,27.38-25.62,32.262
			c-0.466-4.882-13.975-16.45-25.62-32.262S91.547,0,91.547,0c-8.385,8.959-6.521,16.81-6.521,16.81c-2.329-6.227,0-12.971,0-12.971
			c-36.335,33.277-22.36,61.245-22.36,61.245c-17.235,27.115-1.862,45.411-1.862,45.411l41.924,31.57
			c2.125-10.539,17.701-8.959,17.701-8.959s15.576-1.58,17.701,8.959l41.925-31.57C180.054,110.495,195.426,92.199,178.191,65.084z"/>
		<path fill="#FCE9DB" d="M184.595,126.345c0,0,11.326-9.575,13.505-21.544c0,0-9.148,8.378-12.198,9.575
			c0,0,11.763-14.843,9.584-23.621c0,0-3.857,8.039-23.089,12.605c-22.557,5.355-37.997,22.274-41.385,39.342l-10.584,1.727
			l-10.583-1.727c-3.389-17.068-18.829-33.987-41.386-39.342c-19.232-4.567-23.089-12.605-23.089-12.605
			c-2.178,8.777,9.584,23.621,9.584,23.621c-3.049-1.197-12.197-9.575-12.197-9.575c2.178,11.969,13.505,21.544,13.505,21.544
			c-8.597-2.545-10.456-6.783-10.456-6.783s-0.628,6.775,9.228,13.477c7.118,4.84,13.716,9.24,41.147,15.884
			c7.633,1.849,14.649,11.5,24.157,11.622v0.006c0.03,0,0.06-0.002,0.09-0.003c0.03,0.001,0.06,0.003,0.09,0.003v-0.006
			c9.509-0.121,16.524-9.773,24.157-11.622c27.432-6.644,34.029-11.043,41.148-15.884c9.856-6.702,9.227-13.477,9.227-13.477
			S193.191,123.8,184.595,126.345z"/>
		<path fill="#FCF3EB" d="M126.801,127.519c-3.36,0.044-5.288,1.602-6.373,3.64c-1.084-2.038-3.013-3.596-6.372-3.64
			c-9.932-0.132-12.177,11.023-9.445,15.222c2.731,4.199,10.462,5.54,12.403,4.392c1.632-0.966,2.723-2.458,3.414-3.732
			c0.691,1.274,1.782,2.766,3.414,3.732c1.941,1.149,9.673-0.192,12.404-4.392C138.977,138.542,136.733,127.387,126.801,127.519z"/>
		<g>
			<path fill="#FCF3EB" d="M130.222,133.162c0.109-1.139,0.174-2.348,0.174-3.653c0-11.523-7.298-28.236-9.968-28.236
				c-2.67,0-9.968,16.713-9.968,28.236c0,1.305,0.065,2.515,0.175,3.653H130.222z"/>
			<g>
				<path fill="#332A24" d="M120.428,129.329c-6.94,0-10.163,3.14-10.163,3.14s6.874,9.431,10.163,9.596
					c3.29-0.165,10.163-9.596,10.163-9.596S127.369,129.329,120.428,129.329z"/>
				<path fill="#424140" d="M120.428,130.913c5.967,0,9.248,1.176,10.16,1.56l0.003-0.004c0,0-3.223-3.14-10.163-3.14
					c-6.94,0-10.163,3.14-10.163,3.14l0.004,0.004C111.181,132.09,114.461,130.913,120.428,130.913z"/>
			</g>
		</g>
		<g>
			<path fill="#FCF3EB" d="M149.931,61.751c0,0,10.552-6.236,24.462,0c0,0,7.435-28.779-8.394-37.413
				C160.756,21.479,145.374,43.25,149.931,61.751z"/>
			<path fill="#FCF3EB" d="M90.926,61.751c0,0-10.553-6.236-24.462,0c0,0-7.435-28.779,8.394-37.413
				C80.1,21.479,95.483,43.25,90.926,61.751z"/>
		</g>
		<g>
			<path fill="#332A24" d="M155.586,20.655c4.336,0,8.293-1.903,11.313-5.036c-3.033-3.823-6.681-7.762-11.067-11.78
				c0,0,2.329,6.744,0,12.971c0,0,1.863-7.852-6.521-16.81c0,0,4.459,9.067,2.342,20.114
				C152.916,20.464,154.232,20.655,155.586,20.655z"/>
			<path fill="#332A24" d="M85.271,20.655c1.354,0,2.67-0.191,3.934-0.541C87.087,9.067,91.547,0,91.547,0
				c-8.385,8.959-6.521,16.81-6.521,16.81c-2.329-6.227,0-12.971,0-12.971c-4.387,4.018-8.034,7.957-11.067,11.78
				C76.977,18.751,80.934,20.655,85.271,20.655z"/>
		</g>
		<g>
			<g>
				<path fill="#332A24" d="M132.785,104.655c0,0,5.1-13.039,21.326-11.037c0,0,1.036,8.019-4.837,11.318
					C143.4,108.236,132.785,104.655,132.785,104.655z"/>
				<g>
					<circle fill="#D69A20" cx="145.466" cy="99.455" r="4.306"/>
					<circle fill="#FFFFFF" cx="144.169" cy="98.113" r="1.733"/>
				</g>
			</g>
			<g>
				<path fill="#332A24" d="M108.073,104.655c0,0-5.1-13.039-21.327-11.037c0,0-1.036,8.019,4.838,11.318
					C97.457,108.236,108.073,104.655,108.073,104.655z"/>
				<g>
					<circle fill="#D69A20" cx="95.391" cy="99.455" r="4.306"/>
					<circle fill="#FFFFFF" cx="96.688" cy="98.113" r="1.733"/>
				</g>
			</g>
		</g>
		<path fill="#CF5F2B" d="M120.428,37.888c-10.009,0-19.642,5.66-19.416,15.565l2.936-1.774c0,0-2.258,3.992,0,10.053
			l2.709-1.774c0,0,2.258,9.609,8.579,16.41l0.903-1.774c0,0,1.129,3.4,4.289,6.357c3.161-2.956,4.29-6.357,4.29-6.357l0.902,1.774
			c6.322-6.8,8.579-16.41,8.579-16.41l2.71,1.774c2.257-6.061,0-10.053,0-10.053l2.935,1.774
			C140.07,43.548,130.437,37.888,120.428,37.888z"/>
		<path fill="#CF5F2B" d="M120.428,37.888c-10.009,0-19.642,5.66-19.416,15.565l2.936-1.774c0,0-2.258,3.992,0,10.053
			l2.709-1.774c0,0,2.258,9.609,8.579,16.41l0.903-1.774c0,0,1.129,3.4,4.289,6.357c3.161-2.956,4.29-6.357,4.29-6.357l0.902,1.774
			c6.322-6.8,8.579-16.41,8.579-16.41l2.71,1.774c2.257-6.061,0-10.053,0-10.053l2.935,1.774
			C140.07,43.548,130.437,37.888,120.428,37.888z"/>
	</g>
	<path fill="#5C4337"opacity="0.1" d="M120.721,37.888c6.396,0,12.624,2.32,16.238,6.574
		c3.074-3.552,6.293-7.444,9.382-11.639c3.145-4.27,4.821-8.624,5.604-12.71c1.719-8.964-0.895-16.625-1.941-19.193
		c-0.003-0.006-0.006-0.013-0.008-0.019c-0.155-0.379-0.272-0.642-0.338-0.782c-0.006-0.012-0.012-0.027-0.017-0.037
		C149.622,0.039,149.603,0,149.603,0c1.048,1.12,1.936,2.222,2.688,3.294c0.751,1.072,1.366,2.114,1.868,3.112
		c0.503,0.998,0.892,1.952,1.192,2.85c1.5,4.485,0.774,7.55,0.773,7.554c0.873-2.335,1.092-4.743,1.023-6.84
		c-0.034-1.049-0.14-2.02-0.271-2.866c-0.307-1.974-0.752-3.265-0.752-3.265l0,0l0,0c0.042,0.039,0.082,0.077,0.124,0.116
		c0.512,0.47,1.016,0.94,1.508,1.407c0.274,0.262,0.539,0.522,0.808,0.783c0.248,0.241,0.502,0.482,0.745,0.723
		c0.361,0.357,0.711,0.713,1.061,1.068c0.137,0.139,0.278,0.279,0.413,0.418c0.398,0.408,0.784,0.815,1.167,1.222
		c0.079,0.084,0.162,0.169,0.241,0.253c0.419,0.447,0.826,0.893,1.227,1.338c0.036,0.04,0.074,0.081,0.11,0.121
		c0.427,0.475,0.843,0.947,1.25,1.419c0.008,0.009,0.017,0.019,0.025,0.028c25.231,29.218,13.68,52.349,13.68,52.349
		c8.955,14.088,9.103,25.786,7.182,33.784c8.141-4.009,10.113-8.113,10.113-8.113c0.559,2.251,0.197,4.899-0.644,7.595
		c-0.387,4.531-3.009,9.785-5.446,13.795c3.821-2.876,8.704-7.345,8.704-7.345c-0.281,1.544-0.717,3.048-1.259,4.497
		c0.254-0.229,0.397-0.36,0.397-0.36c-1.106,6.081-4.574,11.541-7.719,15.444c4.418-2.315,5.531-4.82,5.531-4.82
		s0.155,1.762-0.986,4.372c0.084-0.146,0.125-0.234,0.125-0.234s0.628,6.775-9.228,13.477c-0.526,0.358-1.051,0.713-1.58,1.067
		c0.716,3.638,1.1,7.723,0.995,12.341l-9.667-5.843c0,0,7.436,13.146,0,33.11l-8.923-5.843c0,0-7.436,31.65-28.256,54.047
		l-2.975-5.843c0,0-3.718,11.199-14.128,20.937V37.888z"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>

  </Icon>
  )
}
